import { connect } from 'react-redux';

const CancelForm = () => ({
  type: 'CANCEL_SUBMIT',
});

export default (WrappedComponent) => connect(null, { CancelForm })(WrappedComponent);
